import { useNavigate } from "react-router-dom"
import { supabase } from "../../api"
import { useCallback, useContext, useState } from "react"
import useError from "../../hooks/useError"
import { SnackbarContext } from "../../contexts/SnackbarContext"
import { WordlistSnapshot } from "../../types/wordlist/WordlistSnapshot"

export default function useWordlistOptionsButtonMenu(wordlistSnapshot: WordlistSnapshot, onRemove: (() => void) | null) {
    const navigate = useNavigate()
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [confirmationModalIsOpen, setConfirmationModalOpen] = useState<boolean>(false)
    const { handleError } = useError()
    const { snackbarSuccess } = useContext(SnackbarContext)
    const isOpen = Boolean(anchorEl)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleClickEdit = () => {
        navigate("/wordlist/" + wordlistSnapshot.id)
        handleClose()
    }

    const handleClickDelete = () => {
        setConfirmationModalOpen(true)
        handleClose()
    }

    const handleDelete = useCallback(async () => {
        if (!onRemove)
            return

        const { data, error } = await supabase.from("wordlist").delete().eq("id", wordlistSnapshot.id).select().single()
        if (error) {
            handleError(error)
            return
        }

        navigate("/")
        snackbarSuccess(`${data.name} has been deleted.`)
        onRemove()
    }, [handleError, navigate, onRemove, snackbarSuccess, wordlistSnapshot.id])

    return {
        isOpen,
        anchorEl,
        confirmationModalIsOpen,
        setConfirmationModalOpen,
        handleClick,
        handleClose,
        handleClickEdit,
        handleClickDelete,
        handleDelete
    }
}
